import React from 'react';
import { FormInput } from '../merchants/FormInput';
import { InputType } from '../form/form-input-constants';
import { useFormik } from 'formik';
import {
	AGENCY_FORM_FIELD, AGENCY_FORM_FIELD_NAMES,
	AgencyTypes, convertToAgencyInitial,
	getAgencyDetailsSchema, IAgency,
	initialAgencyValues
} from '../../constants/new-agency/new-agency-form';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { setAgency } from '../../store/merchnts/actions/agents';
import { useTranslation } from 'react-i18next';
import { NEW_AGENCY_INPUTS } from '../../constants/new-agency/new-agency-inputs';

interface Props {
	onCancel: () => void;
	onSuccess: () => void;
	onError: () => void;
	agency?: IAgency;
	setChosenAgency?: (value: IAgency | null) => void;
}

export const AddNewAgency = (props: Props): React.ReactElement => {
	const { onCancel, onSuccess, onError, agency, setChosenAgency } = props;
	const { t } = useTranslation();
	const { merchantState: { isSavingNewAgency }, dispatch } = useMerchants();
	const formik = useFormik<AgencyTypes>({
		initialValues: agency ? convertToAgencyInitial(agency) : initialAgencyValues,
		validationSchema: getAgencyDetailsSchema,
		onSubmit: () => setAgency(dispatch, formik, agency, setChosenAgency, onSuccess, onError)
	});

	const INPUTS = NEW_AGENCY_INPUTS();

	return (
		<form className="row px-8" onSubmit={formik.handleSubmit}>
			<FormInput
				formik={formik}
				key={AGENCY_FORM_FIELD.AGENCY_NAME}
				fieldName={AGENCY_FORM_FIELD.AGENCY_NAME}
				label={AGENCY_FORM_FIELD_NAMES.AGENCY_NAME}
				placeholder={`${t('NEW_APPLICATION.ENTER')} ${AGENCY_FORM_FIELD_NAMES.AGENCY_NAME}`}
				required
				inputType={InputType.Text}
				additionalClasses="col-sm-6 col-md-6"
			/>
			<div className="col-6"/>
			{
				INPUTS?.map(item => (
					<FormInput
						{...item}
						formik={formik}
						key={item.key}
					/>
				))
			}

			<div className="w-100 d-flex justify-content-center align-items-center px-7 py-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					onButtonClick={onCancel}
					additionalClass="me-10 btn-sm"
				/>

				<ButtonComponent
					buttonName={t('PARTNERS.SAVE_BTN_NAME')}
					type="submit"
					loading={isSavingNewAgency}
					additionalClass="w-85px btn-sm"
					isDisabled={isSavingNewAgency}
				/>
			</div>
		</form>
	);
};
